import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { apiService } from '../services/apiService';
import './Header.css';

const Header: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = apiService.isAuthenticated();
  const user = apiService.getStoredUser();

  const isActive = (path: string) => {
    return location.pathname === path ? 'nav-link active' : 'nav-link';
  };

  const handleLogout = async () => {
    try {
      await apiService.logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      // Still navigate to login even if API call fails
      navigate('/login');
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="currentcolor">
              <path d="M463.08-80v-190.08l-62.62 63.05-24.25-24.1L480-335.44l103.79 104.31-23.58 24.1-63.29-63.05V-80h-33.84ZM231.13-376.21l-24.1-24.25 63.05-62.62H80v-33.84h190.08l-63.05-63.29 24.1-23.58L335.44-480 231.13-376.21Zm497.9 0L625.23-480l103.8-103.79 24.1 23.58-63.05 63.29H880v33.84H690.08l63.05 62.62-24.1 24.25ZM480-443.85q-14.9 0-25.53-10.62-10.62-10.63-10.62-25.53t10.62-25.94q10.63-11.03 25.53-11.03 15.56 0 26.27 10.7 10.7 10.71 10.7 26.27 0 14.9-11.03 25.53-11.04 10.62-25.94 10.62Zm0-181.38-103.79-103.8 24.25-24.1 62.62 63.05V-880h33.84v189.92l63.29-63.05 23.58 24.1L480-625.23Z"></path>
            </svg>
            <h1>Proven</h1>
          </Link>
        </div>
        <nav className="navigation">
          {!isAuthenticated ? (
            // Not authenticated - show public navigation
            <>
              <Link to="/login" className={isActive('/') || isActive('/login')}>
                Login
              </Link>
              <Link to="/signup" className={isActive('/signup')}>
                Sign Up
              </Link>
            </>
          ) : (
            // Authenticated - show app navigation
            <>
              <Link to="/upload" className={isActive('/upload')}>
                Upload Files
              </Link>
              <Link to="/analysis" className={isActive('/analysis')}>
                Analysis
              </Link>
              <Link to="/reports" className={isActive('/reports')}>
                Reports
              </Link>
              <Link to="/export" className={isActive('/export')}>
                Export
              </Link>
              <Link to="/dashboard" className={isActive('/dashboard')}>
                Dashboard
              </Link>
              <div className="user-info">
                <span className="user-email">{user?.email}</span>
                <button onClick={handleLogout} className="logout-btn">
                  Logout
                </button>
              </div>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;